export const environment = {
  production: true
};

export const appVersion = '2.6.0';

export const mapCreds = {
  clientId:'BiCLDBniEeVHi9HK',
  portalUrl: 'https://aegis-enterprise.cable.comcast.com/arcgis'
};

const isProd = window.location.origin === 'https://xm.optek.comcast.net';
const azureClientId = isProd ? 'e8e08e86-8855-47ff-95e1-d970d91e3683' : '3cbadf2d-f775-4aba-99b9-a99964c5e647';

export const azure = {
  clientId: azureClientId,
  tenantId: '906aefe9-76a7-4f65-b82d-5ec20775d5aa',
  redirectUri: window.location.origin,
  scope: `api://${azureClientId}/xm:access`,
};
